import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CuentaCorrienteService } from '../services/cuenta-corriente.service';
import { UserRole } from '../models/enums';
import { mostrarModuloCc, totalCcHabilitada } from '../utils/cc-visibility.util';

/**
 * Protege las rutas de Cuenta Corriente de clientes: con Total C.C. deshabilitada solo se entra
 * mientras queden cuentas con saldo. Si no, vuelve al listado de clientes.
 */
export const ccModuleGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const ccService = inject(CuentaCorrienteService);
  const router = inject(Router);

  const settings = auth.businessSettings();
  const businessId = auth.userProfile()?.business_id;

  // Con la modalidad habilitada (o el Superadmin, que ve todas las empresas) no hace falta consultar.
  if (auth.userProfile()?.role === UserRole.SUPERADMIN || totalCcHabilitada(settings)) return true;

  let hayCuentasConSaldo = false;
  if (businessId) {
    try {
      hayCuentasConSaldo = await ccService.hayCuentasConSaldo(businessId);
    } catch {
      hayCuentasConSaldo = false;
    }
  }

  return mostrarModuloCc(settings, hayCuentasConSaldo) || router.createUrlTree(['/admin/clients']);
};
